import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { teamWorkspaceService } from '../lib/teamWorkspaceService';
import { UserTeam } from '../types';

export const useTeams = () => {
  return useQuery({
    queryKey: ['teams'],
    queryFn: () => teamWorkspaceService.getUserTeams(),
    staleTime: 30000, // 30 seconds
  });
};

export const useCreateTeam = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: teamWorkspaceService.createTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

export const useDeleteTeam = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: teamWorkspaceService.deleteTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

export const useLeaveTeam = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: teamWorkspaceService.leaveTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

export const useAcceptInvitation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: teamWorkspaceService.acceptTeamInvitation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

export const useDeclineInvitation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: teamWorkspaceService.declineTeamInvitation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

export const useInviteTeamMember = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: teamWorkspaceService.inviteTeamMember,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

